var _title;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var WhatsappLogo = function WhatsappLogo(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    secondaryColor = _ref.secondaryColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 0.97916 * size,
    height: size,
    fill: "none",
    viewBox: "0 0 47 48",
    children: [_title || (_title = /*#__PURE__*/_jsx("title", {})), /*#__PURE__*/_jsx("path", {
      d: "M16 12C12.7 12 10 9.3 10 6C10 2.7 12.7 0 16 0C19.3 0 22 2.7 22 6C22 9.3 19.3 12 16 12ZM16 2C13.8 2 12 3.8 12 6C12 8.2 13.8 10 16 10C18.2 10 20 8.2 20 6C20 3.8 18.2 2 16 2Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M17 33H15V47H17V33Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M22 48H10V21.9L1 12.9C0.3 12.2 0 11.4 0 10.4C0 8.6 1.6 7 3.5 7C4.4 7 5.3 7.4 6 8L12 14H29.5C31.4 14 33 15.6 33 17.5C33 19.4 31.4 21 29.5 21H22V48ZM12 46H20V19H29.5C30.3 19 31 18.3 31 17.5C31 16.7 30.3 16 29.5 16H11.1L4.6 9.4C4.3 9.2 3.9 9 3.5 9C2.7 9 2 9.7 2 10.5C2 10.9 2.2 11.3 2.4 11.6L12 21.2V46Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M29 14.2V2.00001L32 0.600011C33.8 -0.199989 35.9 -0.0999892 37.6 0.800011L38.6 1.40001C39.8 2.10001 41.2 2.20001 42.5 1.80001L47 0.200011V12.3L43.3 13.6C41.5 14.2 39.4 14.1 37.7 13.1L36.7 12.5C35.6 11.8 34.1 11.8 32.9 12.3L29 14.2ZM34.6 10C35.7 10 36.7 10.3 37.6 10.8L38.6 11.4C39.8 12.1 41.2 12.2 42.5 11.8L44.9 11V3.00001L43.2 3.60001C41.4 4.20001 39.3 4.10001 37.6 3.10001L36.6 2.50001C35.5 1.80001 34 1.80001 32.8 2.30001L31 3.30001V11.1L32 10.6C32.8 10.2 33.7 10 34.6 10Z",
      fill: secondaryColor || color
    }), /*#__PURE__*/_jsx("path", {
      d: "M31 19.9H29V26H31V19.9Z",
      fill: secondaryColor || color
    }), /*#__PURE__*/_jsx("path", {
      d: "M31 12.6H29V15H31V12.6Z",
      fill: secondaryColor || color
    })]
  });
};
export default WhatsappLogo;